import React, { Component } from "react";
import styles from "./routeTripsContent.module.scss";
import { withRoutes } from "../../../shared/containers/containerRoutes";
import RouteTitle from "./RouteTitle";
import RouteTripsCreateTool from "./RouteTripsCreateTool";
import RouteTripsList from "./RouteTripsList";
import RouteTripControlPoints from "./RouteTripControlPoints";
import { NavLink } from "react-router-dom";
import { FormControl, Radio } from "@mui/material";
import { states } from "../../../reducers/queriesStates";

class RouteTripsContent extends Component {
  constructor(props) {
    super(props);

    this.state = { workDayTrips: true, dayOffTrips: false };
  }

  componentDidMount() {
    const { onSelectTrip, onSelectRoute, onGetRoutes, selectedRouteId, selectedTripId, routesDataState } = this.props;

    if (routesDataState === states.NOT_REQUESTED) {
      onGetRoutes();
    }

    if (
      routesDataState === states.READY &&
      selectedRouteId === null &&
      selectedTripId === null &&
      window.location.pathname.includes("/trips")
    ) {
      const pathNames = window.location.pathname.split("/");
      if (pathNames.length > 3) {
        onSelectRoute(pathNames[2]);
      }
    }
  }

  componentDidUpdate(prevPeops) {
    const { onSelectTrip, selectedRouteId, selectedTripId, routesDataState, onSelectRoute, routes } = this.props;

    if (routesDataState === states.READY && prevPeops.routesDataState === states.REQUEST) {
      if (selectedRouteId === null && selectedTripId === null && window.location.pathname.includes("/trips")) {
        const pathNames = window.location.pathname.split("/");
        if (pathNames.length > 3) {
          onSelectRoute(pathNames[2]);
        }
      }
    }

    if (selectedRouteId !== null && selectedTripId === null && window.location.pathname.includes("/trips")) {
      const pathNames = window.location.pathname.split("/");

      if (pathNames.length > 4) {
        const route = routes.filter((x) => {
          return x.id === selectedRouteId;
        })[0];

        let trip = null;

        if (route !== null) {
          trip = route.dayOffTrips.filter((x) => {
            return x.id === pathNames[4];
          })[0];

          if (trip !== undefined) {
            onSelectTrip(trip);
          } else {
            trip = route.workDayTrips.filter((x) => {
              return x.id === pathNames[4];
            })[0];

            if (trip !== undefined) {
              onSelectTrip(trip);
            }
          }
        }
      }
    }
  }

  onCheageWorkDay() {
    const { onUnselectTrip } = this.props;
    this.setState({ workDayTrips: true, dayOffTrips: false });
    onUnselectTrip();
  }

  onCheageDayOff() {
    const { onUnselectTrip } = this.props;
    this.setState({ workDayTrips: false, dayOffTrips: true });
    onUnselectTrip();
  }

  weekRadio() {
    const { workDayTrips, dayOffTrips } = this.state;
    const { selectedRouteId } = this.props;

    return (
      <FormControl>
        <div className={styles.radioButtomContainer}>
          <div onClick={this.onCheageWorkDay.bind(this)}>
            <NavLink
              to={`/routes/${selectedRouteId}/trips`}
              className={styles.navigationItem}
              activeClassName={styles.navigationItem_active}
            >
              <Radio checked={workDayTrips} size="small" />
              Будние дни
            </NavLink>
          </div>
          <div onClick={this.onCheageDayOff.bind(this)}>
            <NavLink
              to={`/routes/${selectedRouteId}/trips`}
              className={styles.navigationItem}
              activeClassName={styles.navigationItem_active}
            >
              <Radio checked={dayOffTrips} size="small" />
              Выходные и празники
            </NavLink>
          </div>
        </div>
      </FormControl>
    );
  }

  componentWillUnmount() {
    const { onUnselectTrip } = this.props;
    onUnselectTrip();
  }

  render() {
    const { selectedRouteId, routes, selectedTripId } = this.props;
    const { dayOffTrips } = this.state;

    let route = null;

    if (selectedRouteId !== null) {
      route = routes.filter((x) => {
        return x.id === selectedRouteId;
      })[0];

      if (route == undefined) {
        route = null;
      }
    }



    if (route === null) {
      return <div className={styles.routeTripsContentContainer}></div>;
    }

    return (
      <div className={styles.routeTripsContentContainer}>
        <RouteTitle route={route} />
        {this.weekRadio()}
        <RouteTripsCreateTool route={route} dayOff={dayOffTrips} />
        <div className={styles.routeTripControlPointContainer}>
          <RouteTripsList trips={dayOffTrips ? route.dayOffTrips : route.workDayTrips} />
          <RouteTripControlPoints dayOff={dayOffTrips}/>
        </div>
      </div>
    );
  }
}

export default withRoutes(React.memo(RouteTripsContent));
